import { getIntersectionObserverConstructor } from "../helpers/LazyRenderHelpers";
import { observable, action, makeObservable } from "mobx";
const defaultsOptions = {
    // root: null,
    rootMargin: "0px",
    threshold: .01
};
export class Renderer {
    constructor(props) {
        const _OBS = getIntersectionObserverConstructor();
        this.observer = new _OBS(this.updateOnIdle.bind(this), Object.assign(Object.assign({}, defaultsOptions), props));
        this.isVisible = this.observer["faked"] || false;
        this.idleCallbackID = 0;
        makeObservable(this, {
            isVisible: observable,
            updateVisibility: action
        });
    }
    registerDom(element) {
        this.observer.observe(element);
    }
    unRegisterDom(element) {
        this.observer.unobserve(element);
    }
    updateOnIdle(entries) {
        window.cancelAnimationFrame(this.idleCallbackID);
        this.idleCallbackID = window.requestAnimationFrame(this.updateVisibility.bind(this, entries));
    }
    updateVisibility(entries) {
        const hasVisibleEntry = entries.some(entry => entry.isIntersecting);
        this.isVisible = hasVisibleEntry;
    }
}
//# sourceMappingURL=Renderer.js.map